import { Component, OnInit } from '@angular/core';
import {
  ModalController
} from '@ionic/angular';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-product-settings',
  templateUrl: './product-settings.page.html',
  styleUrls: ['./product-settings.page.scss'],
})
export class ProductSettingsPage implements OnInit {

  constructor(public modalCtrl: ModalController,public db:DataService) { }

  ngOnInit() {
    // console.log(this.db.product_set)
  }

  close(){
    this.modalCtrl.dismiss();
  }

  crazyEvent(event){
    return event.detail.checked;
  }
}
